// extracted by mini-css-extract-plugin
export default {"container":"ComponentCollection_container__3XZ6o","container__components":"ComponentCollection_container__components__1Jpl6"};